module.exports = __webpack_public_path__ + "static/media/a10.9718e1f2.pdf";